import React from 'react';
import { pdpSectionStyle } from 'common/components/page-section/pdp-styles';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { getProductBelong, ProductBelong } from 'features/product-info';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { legalDisclaimerSection } from './pdp-legal-disclaimer.styles';

export type PdpLegalDisclaimerProps = object;

type LegalDisclaimerMappedState = {
  productBelong: ProductBelong;
  className?: string;
};
type LegalDisclaimerConnectedProps = LegalDisclaimerMappedState;

export const LegalDisclaimer: React.FC<PdpLegalDisclaimerProps & LegalDisclaimerConnectedProps> = ({
  productBelong,
  className,
}) => {
  const { t } = useTranslation();
  return productBelong === 'LeroyMerlin' ? (
    <section
      className={cx(pdpSectionStyle, legalDisclaimerSection, className)}
      data-qa="section-low-disclamer"
    >
      <p>{t('legal-disclaimer.part1')}</p>
      <p>{t('legal-disclaimer.part2')}</p>
    </section>
  ) : null;
};

function mapStateToProps(state: RootState) {
  return {
    productBelong: getProductBelong(state),
  };
}

export const PdpLegalDisclaimer = connect(mapStateToProps)(LegalDisclaimer);
